






































































import Vue from 'vue';
import Component from 'vue-class-component';
import BindAttrs from '@/utils/binds-attrs';
import {
  ExtendedDynamicComponent,
  ExtendedDynamicComponentList
} from '@/fields/advanced-field-function-executor/conditional-components.interface';
import {Prop} from 'vue-property-decorator';
import AmetrasDynamicContentDialog from '@/views/AmetrasDynamicContentDialog.vue';
import SubMenuTemplate from '@/views/SubMenuTemplate.vue';
import {SubMenuConfig} from '@/interfaces/submenu.interface';
import AmetrasDynamicContentOverlay from '@/views/AmetrasDynamicContentOverlay.vue';
import {DYNAMIC_FIELD_RESOLVER_INSTANCE} from '@/fields/dynamic-field-resolver';
import AdvancedConfirmDialog, {ConfirmationDialogConfig} from '@/views/AdvancedConfirmDialog.vue';

interface DTSubMenuConfig extends SubMenuConfig {
  actionConfiguration?: DisguiseDto.DTActionConfigurationUnion;
}

/**
 * component renders components conditionally defined by AFFE
 *
 * renderSlot must be either ABOVE or BELOW
 * - ABOVE
 *   Renders components that should be visible above the initial component AND Dialogs AND Submenus
 * - BELOW
 *   Renders components that should be visible below the initial component.
 */
@Component({
  components: {
    AdvancedConfirmDialog,
    AmetrasDynamicContentOverlay,
    SubMenuTemplate,
    AmetrasDynamicContentDialog
  },
  mixins: [BindAttrs]
})
export default class ConditionalComponentRenderer extends Vue {

  @Prop({
    type: Object as () => ExtendedDynamicComponentList,
    required: true
  }) conditionalComponents!: ExtendedDynamicComponentList;
  @Prop({
    required: true
  }) renderSlot!: 'BELOW' | 'ABOVE';
  subMenu: DTSubMenuConfig | null = null;
  dynamicFieldResolver = DYNAMIC_FIELD_RESOLVER_INSTANCE;

  generateSubmenuConfigForConditionalComponent(conditionalComponent: ExtendedDynamicComponent): SubMenuConfig {
    if (conditionalComponent['@type'] === 'SubMenuComponent') {
      const castedType = conditionalComponent as DisguiseDto.SubMenuComponent;
      return {
        contextParameter: conditionalComponent.primaryKey,
        title: castedType.subMenuTitle || '',
        breadcrumbs: [],
        id: castedType.subNaviId,
        url: castedType.subNaviUrl || '',
        maxWidthInPx: castedType.maxWidthInPx,
        minHeightInPx: castedType.minHeightInPx,
        hideLogo: true,
        closeButtonPosition: 'RIGHT',
        customTransition: ''
      };
    } else {
      throw new Error('Unexpected type');
    }
  }

  generateConfirmationDialogConfig(dynamicContent: DisguiseDto.AdvancedConfirmDialogComponent) {

    const closeConfirmationDialog = () => {
      const castedExtendedDynamicComponent = dynamicContent as ExtendedDynamicComponent;
      if (castedExtendedDynamicComponent.on) {
        const closeListener = castedExtendedDynamicComponent.on.close;
        if (closeListener) {
          closeListener(undefined);
        }
      }
    };

    return {
      title: dynamicContent.title,
      headerColor: dynamicContent.headerColor !== undefined ? String(dynamicContent.headerColor).toLowerCase() : undefined,
      message: dynamicContent.message,
      buttons: [],
      closeButton: {
        ...dynamicContent.closeButton,
        onClick: (event) => {
          event.stopPropagation();
          closeConfirmationDialog();
        }
      },
      onEsc: (event) => {
        event.stopPropagation();
        closeConfirmationDialog();
      }
    } as ConfirmationDialogConfig;
  }

  closeSubmenuDialog() {
    this.subMenu = null;
  }
}
